const d=(d,a)=>(null==d?void 0:d.id)?`ads:${null==d?void 0:d.id}|campaignId:${null==d?void 0:d.campaignId}`:a;export{d as default};
